import { Link, useLocation } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';
import { SEO } from '@/components/SEO';

// The router previously had no catch-all, so any unmatched URL — including
// several links that pointed at pages which were never built — rendered a
// blank white screen with no way back.
export function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex items-center" style={{ background: '#F7F5EE' }}>
      <SEO
        title="Page Not Found | Marple & Co"
        description="The page you were looking for doesn't exist."
        path={location.pathname}
        noIndex
      />
      <div className="container-marple py-24 text-center max-w-xl mx-auto">
        <p className="font-display text-7xl font-bold mb-4" style={{ color: '#BDD630' }}>404</p>
        <h1 className="font-serif text-3xl sm:text-4xl font-bold mb-4" style={{ color: '#1A2E12' }}>
          This page has gone to ground
        </h1>
        <p className="text-lg mb-10" style={{ color: '#6B7B6E' }}>
          We couldn't find <span className="font-medium">{location.pathname}</span>. It may have
          moved, or never existed.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold transition-transform hover:scale-105"
            style={{ background: '#BDD630', color: '#567D38' }}
          >
            <Home className="w-4 h-4" />
            Home
          </Link>
          <Link
            to="/shop"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold border-2 transition-colors hover:bg-white"
            style={{ borderColor: '#567D38', color: '#567D38' }}
          >
            <Search className="w-4 h-4" />
            Shop
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold transition-colors hover:bg-white"
            style={{ color: '#6B7B6E' }}
          >
            <ArrowLeft className="w-4 h-4" />
            Go back
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
